export default __webpack_public_path__ + "static/media/standard-dish.50b8b357.png";